import { useTranslation } from "react-i18next";

/** Turns an English source string into a stable translation key segment. */
export function toKey(value: string) {
  return value
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

/**
 * Content coming from the (mock) API is authored in English. These helpers look
 * the value up in the active locale and fall back to the original string, so a
 * missing key never renders as a raw key.
 */
export function useLocalizedContent() {
  const { t, i18n } = useTranslation();

  const tx = (namespace: string, value: string) =>
    value ? t(`${namespace}.${toKey(value)}`, { defaultValue: value }) : value;

  return {
    lang: i18n.language,
    tx,
    productName: (value: string) => tx("products", value),
    productCategory: (value: string) => tx("productCategories", value),
    colorName: (value: string) => tx("colors", value),
    sizeName: (value: string) => tx("sizes", value),
    collectionTitle: (value: string) => tx("collections", value),
    ctaLabel: (value: string) => tx("ctas", value),
  };
}
